import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: ${cssTheme.layout.spacing.s200};
  background-color: ${cssTheme.colors.background.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.lg};
  padding: ${cssTheme.layout.spacing.s500};
  &.--layout-primary {
    flex-direction: row;
    align-items: flex-start;
    gap: ${cssTheme.layout.spacing.s500};
    width: auto;
    padding: ${cssTheme.layout.spacing.s500} ${cssTheme.layout.spacing.s400};
  }
`

export const CheckInOutWrapper = styled.div`
  display: flex;
  gap: ${cssTheme.layout.spacing.s200};
`

export const DetailsWrapper = styled.div<{
  alignedRight?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: ${({alignedRight = false}) =>
    alignedRight ? 'flex-end' : 'flex-start'};
  row-gap: 0;
  flex-wrap: wrap;
`

export const CheckInTextContainer = styled(Text)`
  display: flex;
  flex-direction: row;
  gap: ${cssTheme.layout.spacing.s100};
  .--layout-primary & {
    flex-direction: column;
    gap: 0;
  }
`

export const DottedLineContainer = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-top: 0;
  min-width: ${cssTheme.layout.spacing.s900};
  .--layout-primary & {
    margin-top: ${cssTheme.layout.spacing.s600};
    min-width: auto;
  }
`

export const DottedLine = styled.div`
  border-bottom: 2px dotted ${cssTheme.colors.border.neutral.primary};
  flex-grow: 1;
  margin: ${cssTheme.layout.spacing.s000} ${cssTheme.layout.spacing.s200};
`

export const Circle = styled.div`
  width: ${cssTheme.layout.spacing.s300};
  height: ${cssTheme.layout.spacing.s300};
  background: ${cssTheme.colors.border.neutral.primary};
  border-radius: 100%;
`

export const PrimaryLoadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${cssTheme.colors.background.neutral.disabled};
  border-radius: ${cssTheme.layout.radius.lg};
  padding: ${cssTheme.layout.spacing.s500};
`

export const SecondaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  &.--has-gap {
    gap: ${cssTheme.layout.spacing.s500};
  }
`
